import React from 'react';
import LandingPageLayoutFooter from './LandingPageLayoutFooter';

const LandingPageLayout = ({ classAdd, children, id } = props) => {
    return (
        <section id={id} className={`col-xs-16${classAdd ? ` ${classAdd}` : ''}`}>
            <div className="container">
                { children }
            </div>
        </section>
    );
};

export default LandingPageLayout;